module.exports = __webpack_public_path__ + "419292fe8387a75bfe853311592f4d45.otf";